import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextarea,_vm._b({class:_vm.schema['x-class'],attrs:{"rules":_vm.localRules,"label":_vm.localLabel,"disabled":_vm.disabled},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}},'v-textarea',_vm.localProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }